import { useRecoilValue } from 'recoil';
import MVisionBlackLogoSVG from '~/assets/logo-mvision-b.svg';
import MVisionWhiteLogoSVG from '~/assets/logo-mvision-w.svg';
import { themeState } from '~/state/atoms/themeAtoms';

export default function MVisionLogo({ height = 24 }: { height?: number }) {
    const theme = useRecoilValue(themeState);
    return (
        <img
            src={theme === 'dark' ? MVisionWhiteLogoSVG : MVisionBlackLogoSVG}
            alt="Logo"
            width="auto"
            height={height}
            style={{ pointerEvents: 'none' }}
        />
    );
}
